export default "__VITE_ASSET__BM8e_RnG__"